globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactsImportWizard = (function(superClass) {

  utils.extend(ContactsImportWizard, superClass);

  function ContactsImportWizard() {
    return ContactsImportWizard.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactsImportWizard.prototype, {
    init: function() {
      var modal = this;
      var $innerContent = modal.$html.find(".modal-inner-content");

      modal._unbindEvents();

      var isTemplateStep = $innerContent.hasClass("modal-template-step");
      var isUploadStep = $innerContent.hasClass("modal-upload-step");
      var isAnalysisStep = $innerContent.hasClass("modal-analysis-step");
      var isPreValidationStep = $innerContent.hasClass("modal-pre-validation-step");

      if (isTemplateStep) {
        modal._initTemplateStep();
      }
      if (isUploadStep) {
        modal._initUploadStep();
      }
      if (isAnalysisStep) {
        modal._initAnalysisStep();
      }
      if (isPreValidationStep) {
        modal._initPreValidationStep();
      }

      modal._initNextStepNavigation();
      appCustomerSpace.LimitlessPlugins.Checkbox.init(modal.$html);

      return ContactsImportWizard.__super__.init.apply(this, arguments);
    },

    _unbindEvents: function() {
      var modal = this;
      modal.$html.off("click", ".wizard-next-step");
      modal.$html.off("click", ".wizard-upload-submit");
      modal.$html.off("click", ".wizard-validate-btn");
      modal.$html.off("change", ".wizard-analysis-checkbox");
      modal.$html.off("change", ".wizard-rgpd-checkbox");
      if (modal._cableSubscription) {
        modal._cableSubscription.unsubscribe();
        modal._cableSubscription = null;
      }
    },

    _initNextStepNavigation: function() {
      var modal = this;

      modal.$html.on("click", ".wizard-next-step", function(event) {
        event.preventDefault();
        var step = $(this).data("step");
        var listUniqKey = $(this).data("list-uniq-key");
        var extraParams = {};
        if (listUniqKey) {
          extraParams.list_uniq_key = listUniqKey;
        }
        modal._navigateToStep(step, extraParams);
      });
    },

    _initTemplateStep: function() {
    },

    _initUploadStep: function() {
      var modal = this;
      var $uploadBtn = modal.$html.find(".wizard-upload-btn");
      var $fileInput = modal.$html.find(".wizard-upload-file-input");
      var $submitBtn = modal.$html.find(".wizard-upload-submit");

      $uploadBtn.on("click", function(event) {
        event.preventDefault();
        $fileInput.trigger("click");
      });

      $fileInput.on("change", function() {
        if ($(this).val() !== undefined && $(this).val().length > 0) {
          $uploadBtn.hide();
          $(this).show();
          $submitBtn.removeAttr("disabled");
        }
      });

      modal.$html.on("click", ".wizard-upload-submit", function(event) {
        event.preventDefault();
        appCustomerSpace.Loader().start({ $container: modal.$html.find(".modal-content") });
        var $form = modal.$html.find(".wizard-upload-form");

        $.ajax({
          type: "POST",
          url: $form.attr("action"),
          data: new FormData($form[0]),
          processData: false,
          contentType: false,
          success: function(data) {
            if (data.response && data.html) {
              appCustomerSpace.Loader().stop();
              modal.$html.find(".modal-content").html($(data.html));
              new appCustomerSpace.Modals.Settings.ContactsImportWizard(modal.$html).init();
            } else {
              appCustomerSpace.Loader().stop();
              alert(data.error || "Une erreur est survenue");
            }
          }
        });
      });
    },

    _initAnalysisStep: function() {
      var modal = this;
      var listUniqKey = modal.$html.find(".modal-inner-content").attr("data-list-uniq-key");
      var $loaderContainer = modal.$html.find(".wizard-analysis-loader");
      var loaderMessages = ["Envoi du fichier…", "Analyse…", "Préparation d'un échantillon"];
      var messageIndex = 0;

      appCustomerSpace.Loader().start({
        $container: $loaderContainer,
        options: { text: loaderMessages[0] }
      });

      var messageInterval = setInterval(function() {
        messageIndex++;
        if (messageIndex < loaderMessages.length) {
          appCustomerSpace.Loader().set({
            $container: $loaderContainer,
            options: { text: loaderMessages[messageIndex] }
          });
        }
      }, 2000);

      modal._cableSubscription = App.cable.subscriptions.create({
        channel: "CustomerSpace::Crm::ImportContactsChannel",
        list_uniq_key: listUniqKey
      }, {
        received: function(data) {
          clearInterval(messageInterval);
          appCustomerSpace.Loader().stop({ $container: $loaderContainer });
          switch (data.action) {
            case "update_analysis":
              modal.$html.find(".modal-content").html($(data.html));
              new appCustomerSpace.Modals.Settings.ContactsImportWizard(modal.$html).init();
              break;
          }
        }
      });

      modal.$html.on("change", ".wizard-analysis-checkbox", function() {
        var $nextBtn = modal.$html.find(".wizard-next-step");
        if ($(this).is(":checked")) {
          $nextBtn.removeAttr("disabled");
        } else {
          $nextBtn.attr("disabled", true);
        }
      });
    },

    _initPreValidationStep: function() {
      var modal = this;
      var $rgpdCheckbox = modal.$html.find(".wizard-rgpd-checkbox");
      var $validateBtn = modal.$html.find(".wizard-validate-btn");

      $rgpdCheckbox.on("change", function() {
        if ($(this).is(":checked")) {
          $validateBtn.removeAttr("disabled");
        } else {
          $validateBtn.attr("disabled", true);
        }
      });

      modal.$html.on("click", ".wizard-validate-btn", function(event) {
        event.preventDefault();
        appCustomerSpace.Loader().start({ $container: modal.$html.find(".modal-content") });
        var $form = modal.$html.find(".wizard-validate-form");

        $.ajax({
          type: "POST",
          url: $form.attr("action"),
          data: $form.serialize(),
          success: function(data) {
            if (data.response && data.html) {
              appCustomerSpace.Loader().stop();
              modal.close(function() {
                appCustomerSpace.Modal.mountCurrentModal($(data.html)).open({});
              });
            } else {
              appCustomerSpace.Loader().stop();
              alert(data.error || "Une erreur est survenue");
            }
          }
        });
      });
    },

    _navigateToStep: function(step, extraParams) {
      var modal = this;
      var $wizard = modal.$html.closest(".crm-import-wizard");
      appCustomerSpace.Loader().start({ $container: modal.$html.find(".modal-content") });

      var data = { step: step };
      var listId = $wizard.data("list-id");
      var redirectUrl = $wizard.data("redirect-url");
      var brevo = $wizard.data("brevo");
      if (listId) { data.list_id = listId; }
      if (redirectUrl) { data.redirect_url = redirectUrl; }
      if (brevo === true || brevo === "true") { data.brevo = true; }
      if (extraParams) {
        $.extend(data, extraParams);
      }

      $.ajax({
        type: "POST",
        url: modal.$html.closest(".crm-import-wizard").data("wizard-step-url"),
        data: data,
        success: function(response) {
          if (response.response && response.html) {
            appCustomerSpace.Loader().stop();
            modal.$html.find(".modal-content").html($(response.html));
            new appCustomerSpace.Modals.Settings.ContactsImportWizard(modal.$html).init();
          }
        }
      });
    }
  });

  return ContactsImportWizard;

})(appCustomerSpace.Modal);
